import { createAction } from 'redux-actions';

export const requestGetAgentDetailsAction = createAction('REQUEST/AGENT_DETAILS');
export const getAgentTeamDocumentsAction = createAction('REQUEST/AGENT_TEAM_DOCUMENTS');
export const updateAgentProfileAction = createAction('REQUEST/UPDATE_AGENT_PROFILE');
export const updateAgentActiveStatusAction = createAction('REQUEST/UPDATE_AGENT_ACTIVE_STATUS');
export const updateAgentRoleAction = createAction('REQUEST/UPDATE_AGENT_ROLE');
export const assignAdminsToMemberAction = createAction('REQUEST/ASSIGN_MEMBER_ADMINS');
